import {
    type StartEventApplicationResponseType,
    type StartEventApplicationRequestType
} from "./type";
import {
    request
} from "../request";

const StartEventApplication = async (params: StartEventApplicationRequestType): Promise<StartEventApplicationResponseType> => {
    return await request<StartEventApplicationResponseType>("/events/startEventApplication", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default StartEventApplication;
